import React from 'react'
import { Box } from '@node-space/ui-components'

export const CardActivityTab = () => {
  return (
    <Box paddingT={16} className="text-foreground-prominent">
      Card activity to be implemented when API will be ready
    </Box>
  )
}
